import { formatMoneyWithCurrency } from '@/Ship/Helpers/formatNumber'

/** Гроші звітів — у базовій валюті тенанта, гривні (`SPEC-027` §3.3). */
export const REPORT_CURRENCY = 'UAH'

export const formatReportMoney = (value: number): string => formatMoneyWithCurrency(value, REPORT_CURRENCY)

/** Відсоток — один знак після коми, як округлює бек (Ф-05). */
export const formatReportPercent = (value: number): string =>
    `${new Intl.NumberFormat('uk-UA', { maximumFractionDigits: 1 }).format(value)} %`

export const formatReportCount = (value: number): string => new Intl.NumberFormat('uk-UA').format(value)
